import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { categoryIcon } from "../../constants/categoryIcons";

export default function Categories() {
  const { content } = useContent();
  const productCategories = content.productCategories || [];
  return (
    <section className="py-20 lg:py-24 bg-[#0f2236]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-[#2ED9B8] font-medium">Product categories</p>
          <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.08] text-foreground">
            A wide range of categories to meet global needs
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-5">
          {productCategories.map((c, i) => {
            const IconCmp = categoryIcon(c);
            return (
              <Reveal key={c.name} delay={(i % 4) * 70}>
                <Link
                  to="/products"
                  className="group block h-full bg-card rounded-2xl border border-white/10 p-6 hover:border-[#2ED9B8]/30 hover:shadow-[0_20px_40px_-24px_rgba(12,97,82,0.4)] transition-all duration-300"
                >
                  <div className="h-12 w-12 rounded-xl bg-[#0f2236] flex items-center justify-center group-hover:bg-[#00ab96] transition-colors">
                    <IconCmp className="h-6 w-6 text-[#2ED9B8] group-hover:text-white transition-colors" strokeWidth={1.8} />
                  </div>
                  <h3 className="mt-5 font-display text-[19px] text-foreground leading-tight">{c.name}</h3>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#2ED9B8] font-medium">
                    Explore <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={120} className="mt-10">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 bg-[#00ab96] hover:bg-[#0b8f7e] text-white rounded-full px-6 h-12 font-medium transition-colors"
          >
            Explore all categories <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
